import React from 'react'
import { Container } from './Main.styles'
import MainProps from './Main.types'

const Main: React.FC<MainProps> = ({ children }) => {
  return <Container>{children}</Container>
}

export default Main
